import { render } from "./InitPayment.vue?vue&type=template&id=44904378"
import script from "./InitPayment.vue?vue&type=script&lang=js"
export * from "./InitPayment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__